<style lang="less">
</style>
<template>
    <span>
        <Drawer title="场次安排" :closable="false" placement="right" v-model="examination" width="60%">
            <Row class="operation">
                <Button @click="add" type="primary" icon="md-add">新增场次</Button>
                <circleLoading v-if="operationLoading"/>
            </Row>
            <Row style="padding-top: 5px">
                <Table :loading="loading" border :columns="columns" :data="data" ref="userTable"></Table>
            </Row>
            <Row type="flex" justify="end" class="page">
                <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
            </Row>
        </Drawer>
        <sessions-drawer ref="sessionsDrawer"></sessions-drawer>
        <timeArrangeManage ref="timeArrangeManage"></timeArrangeManage>
    </span>
</template>

<script>
    import {selectSessionsList, setSessionsStatus} from "@/api/bus";
    import sessionsDrawer from "./sessions-drawer";
    import timeArrangeManage from "./timeArrangeManage";
    export default {
        name: "sessions-manage",
        components: {
            sessionsDrawer,
            timeArrangeManage
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                examination: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "examStartTime", // 默认排序字段
                    order: "asc", // 默认排序方式
                    examinationId: "",
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    {
                        type: "index",
                        width: 50,
                        align: "center"
                    },
                    {
                        title: "场次名称",
                        align: "center",
                        key: "childexamName"
                    },
                    {
                        title: "考试日期",
                        align: "center",
                        key: "examTime"
                    },
                    {
                        title: "是否开启",
                        key: "status",
                        align: "center",
                        width: 120,
                        render: (h, params) => {
                            return h(
                                "i-switch",
                                {
                                    props: {
                                        value: params.row.status,
                                        size: "large",
                                        "true-value": '1',
                                        "false-value": '0'
                                    },
                                    on: {
                                        "on-change": v => {
                                            this.setSessionsStatus(params.row,v);
                                        }
                                    }
                                },
                                [
                                    h("span", {slot: "open"}, "已发布"),
                                    h("span", {slot: "close"}, "未发布")
                                ]
                            );
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "info",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.timeList(params.row);
                                            }
                                        }
                                    },
                                    "时间"
                                ),
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            showDrawer(params){
                this.examination = true;
                if (params.id) {
                    this.searchForm.examinationId = params.id;
                    this.getDataList();
                }
            },
            getDataList() {
                this.loading = true;
                selectSessionsList(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                        console.info(this.data)
                    }
                });
            },
            //设置发布状态
            setSessionsStatus(row,v){
                let params={
                    id:row.id,
                    status:v
                };
                setSessionsStatus(params).then(res => {
                    if (res.status === true) {
                        this.$Message.success(res.info);
                    }
                });
            },
            edit(v) {
                this.$refs.sessionsDrawer.showDrawer(v);
            },
            add() {
                let query = {examinationId: this.searchForm.examinationId}
                this.$refs.sessionsDrawer.showDrawer(query);
            },
            timeList(v){
                let query = {examseasonId: v.id}
                this.$refs.timeArrangeManage.showDrawer(query);
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
        },
        mounted() {
        }
    }
</script>
